import A11yDialog from 'a11y-dialog'
import Cart from './Cart'

const Modal = {
  init: () => {
    if (document.getElementById('classes-confirm-modal')) {
      Modal.classesConfirm()
    }
    if (document.getElementById('general-confirm-modal')) {
      Modal.generalConfirm()
    }
    if (document.getElementById('waiver-modal')) {
      Modal.waiverConfirm()
      document.addEventListener('click', Modal.waiverClickHandler)
    }
  },
  classesConfirm: () => {
    window.modal = new A11yDialog(document.getElementById('classes-confirm-modal'))
    const dialogContent = document.getElementById('classes-confirm-modal-content')

    window.modal.on('show', async (dialog, event) => {
      if (window.confirming) {
        const content = document.getElementById(`confirm-modal-desc-${window.confirming}`)
        const source = document.querySelector(`[data-product-id="${window.confirming}"]`)
        document.body.classList.add('modal-open')
        document.documentElement.style.overflowY = 'hidden'

        if (source) {
          dialogContent.innerHTML = content.innerHTML
          
          const loading = document.createElement('div');
          dialogContent.appendChild(loading)
          loading.setAttribute('class', 'mt-4 text-center')
          loading.innerHTML = 'loading...'
  
          // get subscription
          const request = await Cart.getSubscription({
            id: window.confirming,
          })
          const response = JSON.parse(request)
          // console.log('get sub response', response)
  
          if (response.show_button) {
            // add button
            loading.innerHTML = `
              <button 
                class="mt-4 w-full bg-c-purple-dark hover:bg-c-purple hover:text-white rounded-2xl inline-block uppercase py-6 px-8 lg:px-12 text-white md:text-lg font-normal leading-none transition duration-300 ease-linear focus:outline-none" 
                title="Confirm" 
                aria-label="Confirm" 
                data-cart-add data-confirm="true" data-loading-text="Confirming" data-product-id="${window.confirming}"
                data-nonce="${source.getAttribute('data-nonce')}"
              >
                Confirm
              </button>
            `
            if (response.message) {
              loading.innerHTML += `<p class="mt-4 text-center font-bold">${response.message}</p>`
            }
          } else {
            if (response.message) {
              loading.innerHTML = `<p class="mt-4 text-center font-bold">${response.message}</p>`
            }
          }
        }
      }
    })
    window.modal.on('hide', () => {
      window.confirming = null
      document.body.classList.remove('modal-open')
      document.documentElement.style.overflowY = ''
    })
  },
  generalConfirm: () => {
    window.confirmModal = new A11yDialog(document.getElementById('general-confirm-modal'))
    const dialogTitle = document.getElementById('confirm-modal-title')
    const dialogButton = document.getElementById('general-confirm-modal-button')

    window.confirmModal.on('show', async (dialog, event) => {
      if (window.confirming) {
        if (window.confirming.url) {
          dialogButton.href = window.confirming.url
        } else {
          dialogButton.role = 'button'
          for (let i = 0; i < window.confirming.attr.length; i += 1) {
            const attr = window.confirming.attr[i]
            dialogButton.setAttribute(attr.name, attr.value)
          }
        }
        dialogTitle.textContent = window.confirming.title

        document.body.classList.add('modal-open')
        document.documentElement.style.overflowY = 'hidden'
      }
    })
    window.confirmModal.on('hide', () => {
      window.confirming = null
      dialogButton.textContent = 'Confirm'
      dialogButton.style.display = 'block'
      document.body.classList.remove('modal-open')
      document.documentElement.style.overflowY = ''
    })
  },
  updateGeneralConfirm: (input) => {
    const dialogTitle = document.getElementById('confirm-modal-title')
    const dialogButton = document.getElementById('general-confirm-modal-button')

    if (window.confirmModal) {
      if (input.message) {
        dialogTitle.textContent = input.message
      }
      if (input.hide_button) {
        dialogButton.style.display = 'none'
      }
    }
  },
  waiverConfirm: () => {
    window.waiverModel = new A11yDialog(document.getElementById('waiver-modal'))
    window.waiverModel.on('show', async (dialog, event) => {
      document.documentElement.style.overflowY = 'hidden'
    })
    window.waiverModel.on('hide', async (dialog, event) => {
      document.documentElement.style.overflowY = ''
    })

    window.waiverModel.show()
  },
  waiverClickHandler: (event) => {
    const button = document.getElementById('waiver-confirm-modal-button')
    if (event.target === button) {
      Modal.waiverSendAgree()
      window.waiverModel.hide()
    }
  },
  waiverSendAgree: () => new Promise((resolve) => {
    const request = `${window.settings.requestUrl}?action=user_agree_to_waiver`
      // console.log('request', request)
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(xhr.response);
          } else {
            // reject(xhr.status)
          }
        }
      }
      xhr.open('GET', request, true)
      xhr.send()
  }),
}
export default Modal